import { render, staticRenderFns } from "./dayaoShouYe.vue?vue&type=template&id=2057642c&"
import script from "./dayaoShouYe.vue?vue&type=script&lang=js&"
export * from "./dayaoShouYe.vue?vue&type=script&lang=js&"
import style0 from "./dayaoShouYe.vue?vue&type=style&index=0&id=2057642c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports